
export class DataStandardsContent {
    constructor() {
        $(".expand-all").on("click", () => {
            $(".crf-table-header").css("display", "revert");
            $(".crf-table-body").css("display", "revert");
            $(".collapse-all").css("display", "block");
            $(".expand-all").css("display", "none");
            $(".fa-circle-plus").css("display", "none");
            $(".fa-circle-minus").css("display", "inline-block");

            $(".crf-table-caption").addClass("crf-table-showing");
        });


        $(".collapse-all").on("click", () => {
            $(".crf-table-header").css("display", "none");
            $(".crf-table-body").css("display", "none");
            $(".collapse-all").css("display", "none");
            $(".expand-all").css("display", "block");
            $(".fa-circle-plus").css("display", "inline-block");
            $(".fa-circle-minus").css("display", "none");

            $(".crf-table-caption").removeClass("crf-table-showing");
        });


        $(".crf-table").each((idx, element) => {
            let caption = $(element).find(".crf-table-caption");
            let showBtn = caption.find(".fa-circle-plus");
            let hideBtn = caption.find(".fa-circle-minus")
            let header = $(element).find(".crf-table-header");
            let body = $(element).find(".crf-table-body");

            caption.on("click", () => {
                if (caption.hasClass("crf-table-showing")) {
                    header.css("display", "none");
                    body.css("display", "none");
                    showBtn.css("display", "inline-block");
                    hideBtn.css("display", "none");
                    caption.removeClass("crf-table-showing");
                } else {
                    header.css("display", "revert");
                    body.css("display", "revert");
                    hideBtn.css("display", "inline-block");
                    showBtn.css("display", "none");
                    caption.addClass("crf-table-showing");
                }
            });
        });
    }
}